import { useEffect, useState } from "react";
import { AiOutlineSwap } from "react-icons/ai";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SweetAlert2 from "react-sweetalert2";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { useAuth } from "../../auth/components/AuthInit";
import * as actions from "../redux/MainAction";
import "./nav.css";

function Nav() {
  const intl = useIntl();
  const dispatch = useDispatch();
  const mainState = useSelector(({ main }) => main, shallowEqual);
  const { auth, saveAuth } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [selagentid, setSelagentid] = useState(auth.selagentid ?? auth.agentid);
  const [swalProps, setSwalProps] = useState({});

  useEffect(() => {
    const queryParams = {
      action: "groupcredit",
    };
    dispatch(actions.callGroupCredit(queryParams));
  }, []);

  useEffect(() => {
    const queryParams = {
      action: "cshagentlist",
    };
    dispatch(actions.fetchCashierAgentList(queryParams));
  }, []);

  const balance = mainState.groupCredit?.balance ?? "0.00";
  const acctquota = mainState.groupCredit?.acctquota ?? "0";

  const handleRefreshData = () => {
    setIsLoading(true);

    const params = {
      action: "groupcredit",
    };

    dispatch(actions.callGroupCredit(params));

    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  const handleSwitchAgent = () => {
    const params = {
      action: "cshswitchconfirm",
      selagentid,
    };
    dispatch(actions.switchCashierAgent(params)).then((resp) => {
      resp = resp.data;

      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        saveAuth({ ...auth, ...resp, username: resp.selusername });
        setSwalProps({
          show: true,
          icon: "success",
          title: intl.formatMessage({ id: "success" }),
          text: intl.formatMessage({ id: "switchSuccessfully" }),
          onResolve: () => {
            window.location.reload();
          },
        });
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  return (
    <nav className="header-nav ms-auto m-0">
      <ul className="d-flex align-items-center m-0">
        <SweetAlert2
          customClass="custom-swal"
          onResolve={() => {
            setSwalProps({});
          }}
          {...swalProps}
        />
        <div className="d-flex mobile-fontSize align-items-center">
          {mainState.cashierAgentList?.cshAgentLists.length > 0 && (
            <div className="d-flex align-items-center pe-3 flex-wrap justify-content-end">
              <select
                value={selagentid}
                onChange={(e) => setSelagentid(e.target.value)}
                className="w-md-150"
              >
                {mainState.cashierAgentList?.cshAgentLists.map((cshAgent) => (
                  <option key={cshAgent.agentid} value={cshAgent.agentid}>
                    {cshAgent.username}
                  </option>
                ))}
              </select>
              <button
                type="button"
                className="btn btn-primary py-0 ms-2 d-none d-md-inline"
                onClick={() => handleSwitchAgent()}
              >
                {intl.formatMessage({ id: "toCashierMode" })}
              </button>

              {/* Mobile button */}
              <div
                className="bg-primary d-inline d-md-none px-1 text-white rounded-end py-1"
                onClick={() => handleSwitchAgent()}
              >
                <div className="h-100 w-100 d-flex align-items-center">
                  <AiOutlineSwap />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="d-flex mobile-fontSize align-items-center">
          <div className="d-flex align-items-center">
            <div>{intl.formatMessage({ id: "balance" })}</div>
            <div style={{ margin: "0 2px" }}>{":"}</div>
            <div style={{ marginRight: "5px" }}>
              {isLoading ? "-.--" : balance}
            </div>
          </div>
        </div>
        {isLoading ? (
          <div style={{ width: "20px", height: "20px" }} />
        ) : (
          <i
            className="bi bi-arrow-clockwise"
            style={{ marginRight: "5px" }}
            onClick={handleRefreshData}
          />
        )}
      </ul>
    </nav>
  );
}

export default Nav;
